<app-close [outlet]="'modal'" testId="dialog-add-student-close" />
<app-title tag="h2" tagStyle="h4" [title]="'students.add.title' | translate" />

<app-add />
